var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDribbble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EA4C89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 33.5625C27.4904 33.5625 33.5625 27.4904 33.5625 20C33.5625 12.5096 27.4904 6.4375 20 6.4375C12.5096 6.4375 6.4375 12.5096 6.4375 20C6.4375 27.4904 12.5096 33.5625 20 33.5625Z",
    fill: "#EA4C89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6C12.2712 6 6 12.2712 6 20C6 27.7289 12.2712 34 20 34C27.7137 34 34 27.7289 34 20C34 12.2712 27.7137 6 20 6ZM29.2473 12.4534C30.9176 14.4881 31.9198 17.0846 31.9502 19.8937C31.5554 19.8178 27.6074 19.013 23.6291 19.5141C23.538 19.3167 23.462 19.1041 23.371 18.8916C23.128 18.3146 22.8547 17.7224 22.5813 17.1605C26.9848 15.3688 28.9892 12.7874 29.2473 12.4534ZM20 8.06508C23.0369 8.06508 25.8156 9.20391 27.9263 11.0716C27.7137 11.3753 25.9067 13.7896 21.6551 15.3839C19.6963 11.7852 17.525 8.83948 17.1909 8.38395C18.0867 8.17137 19.0282 8.06508 20 8.06508ZM14.9133 9.18872C15.2321 9.61388 17.3579 12.5748 19.3471 16.0976C13.7592 17.5857 8.8243 17.5553 8.29284 17.5553C9.06724 13.8503 11.5727 10.7679 14.9133 9.18872ZM8.03471 20.0152C8.03471 19.8937 8.03471 19.7722 8.03471 19.6508C8.55098 19.6659 14.3514 19.7419 20.3189 17.9501C20.6682 18.6182 20.987 19.3015 21.2907 19.9848C21.1388 20.0304 20.9718 20.076 20.82 20.1215C14.6551 22.1106 11.3753 27.5466 11.102 28.0022C9.2039 25.8916 8.03471 23.0825 8.03471 20.0152ZM20 31.9653C17.2364 31.9653 14.6855 31.0239 12.6659 29.4447C12.8785 29.0044 15.308 24.3276 22.0499 21.974C22.0802 21.9588 22.0955 21.9588 22.1258 21.9436C23.8113 26.3015 24.4946 29.9609 24.6768 31.0087C23.2343 31.6312 21.6551 31.9653 20 31.9653ZM26.6659 29.9154C26.5445 29.1866 25.9067 25.6942 24.3427 21.3969C28.0933 20.8047 31.3731 21.7766 31.7831 21.9133C31.2669 25.2386 29.3536 28.1085 26.6659 29.9154Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbble);
export default __webpack_public_path__ + "static/media/Dribbble.dec68e931cebf05168d9455b7e4c64dc.svg";
export { ForwardRef as ReactComponent };